import { validate } from "util";

const general = {
  name: {
    presence: {
      allowEmpty: false,
      message: "Nome é obrigatório"
    }
  },
  slug: {
    presence: {
      allowEmpty: false,
      message: "Apelido é obrigatório"
    }
  },
  email: {
    format: {
      pattern: new RegExp(`${validate.validators.email.PATTERN.source}|^$`),
      message: "E-mail com formato inválido"
    }
  },
  phone: {
    presence: {
      allowEmpty: false,
      message: "Telefone é obrigatório"
    },
    format: {
      pattern: /^(\s*|\d{10,11})$/,
      message: "Telefone não preenchido ou com formato inválido"
    }
  },
  "fiscal_informations.legal_name": {
    presence: {
      allowEmpty: false,
      message: "Razão Social é obrigatória"
    }
  },
  "fiscal_informations.cnpj": {
    format: {
      pattern: /^\d{14}$|^$/,
      message: "CNPJ com formato inválido"
    }
  },
  "fiscal_informations.ie": {
    presence: {
      allowEmpty: false,
      message: "Inscrição Estadual é obrigatória"
    },
    format: {
      pattern: /^\d{2,14}$|^$/,
      message: "Inscrição Estadual com formato inválido"
    }
  },
  "fiscal_informations.im": {
    format: {
      pattern: /^\d+$|^$/,
      message: "Inscrição municipal com formato inválido"
    }
  },
  "fiscal_informations.municipal_code": {
    format: {
      pattern: /^\d+$|^$/,
      message: "Código do município inválido"
    }
  },
  "address.zipcode": {
    format: {
      pattern: /^\d{8}$|^$/,
      message: "CEP com formato inválido"
    }
  },
  "address.state": {
    format: {
      pattern: /^RO|AC|AM|RR|PA|AP|TO|MA|PI|CE|RN|PB|PE|AL|SE|BA|MG|ES|RJ|SP|PR|SC|RS|MS|MT|GO|DF|$/,
      message: "Estado inválido"
    }
  },
  max_installments: {
    format: {
      pattern: /^(\s*|[1-9]\d?)$/,
      message:
        "Quantidade de Parcelas máximas deve ser vazia ou um número inteiro entre 1 e 99"
    }
  },
  notify_email: {
    presence: {
      allowEmpty: true,
      message: "E-mail de notificação de estoque mínimo está vazio"
    },
    format: {
      pattern: new RegExp(`${validate.validators.email.PATTERN.source}|^$`),
      message: "E-mail de notificação de estoque mínimo com formato inválido"
    }
  }
};

const taxes = {
  "default_taxes.cfop": {
    format: {
      pattern: /^(\s*|5000|5100|5101|5102|5103|5104|5105|5106|5107|5108|5109|5110|5111|5112|5113|5114|5115|5116|5117|5118|5119|5120|5122|5123|5124|5125|5150|5151|5152|5153|5154|5155|5156|5200|5201|5202|5203|5204|5205|5206|5207|5208|5209|5210|5250|5251|5252|5253|5254|5255|5256|5257|5258|5300|5301|5302|5303|5304|5305|5306|5307|5350|5351|5352|5353|5354|5355|5356|5357|5359|5360|5400|5401|5402|5403|5404|5405|5408|5409|5410|5411|5412|5413|5414|5415|5450|5451|5500|5501|5502|5503|5504|5505|5550|5551|5552|5553|5554|5555|5556|5557|5600|5601|5602|5603|5604|5605|5606|5651|5652|5653|5654|5655|5656|5657|5658|5659|5660|5661|5662|5663|5664|5665|5666|5900|5901|5902|5903|5904|5905|5906|5907|5908|5909|5910|5911|5912|5913|5914|5915|5916|5917|5918|5919|5920|5921|5922|5923|5924|5925|5926|5927|5928|5929|5931|5932|5933|5949|6000|6100|6101|6102|6103|6104|6105|6106|6107|6108|6109|6110|6111|6112|6113|6114|6115|6116|6117|6118|6119|6120|6121|6122|6123|6124|6125|6150|6151|6152|6153|6154|6155|6156|6200|6201|6202|6203|6204|6205|6206|6207|6208|6209|6210|6250|6251|6252|6253|6254|6255|6256|6257|6258|6300|6301|6302|6303|6304|6305|6306|6307|6350|6351|6352|6353|6354|6355|6356|6357|6359|6400|6401|6402|6403|6404|6408|6409|6410|6411|6412|6413|6414|6415|6500|6501|6502|6503|6504|6505|6550|6551|6552|6553|6554|6555|6556|6557|6600|6603|6651|6652|6653|6654|6655|6656|6657|6658|6659|6660|6661|6662|6663|6664|6665|6666|6900|6901|6902|6903|6904|6905|6906|6907|6908|6909|6910|6911|6912|6913|6914|6915|6916|6917|6918|6919|6920|6921|6922|6923|6924|6925|6929|6931|6932|6933|6949|7000|7100|7101|7102|7103|7104|7105|7106|7127|7200|7201|7202|7203|7204|7205|7206|7207|7210|7211|7250|7251|7300|7301|7350|7358|7500|7501|7550|7551|7553|7556|7651|7654|7900|7930|7949)$/,
      message: "CFOP inválido. Deve ser vazio ou conter um valor válido"
    }
  },
  "default_taxes.pis_normal.cst": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (attributes.fiscal_informations.crt_code !== "3") {
      return null;
    }

    return {
      presence: {
        allowEmpty: false
      },
      format: {
        pattern: /^(\s*|01|02|03|04|05|06|07|08|09|49|99)$/,
        message: "PIS CST inválido. Deve ser vazio ou conter um valor válido"
      }
    };
  },
  "default_taxes.cofins_normal.cst": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (attributes.fiscal_informations.crt_code !== "3") {
      return null;
    }

    return {
      presence: {
        allowEmpty: false
      },
      format: {
        pattern: /^(\s*|01|02|03|04|05|06|07|08|09|49)$/,
        message: "COFINS CST inválido. Deve ser vazio ou conter um valor válido"
      }
    };
  },
  "default_taxes.icms.cst": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (attributes.fiscal_informations.crt_code !== "3") {
      return null;
    }
    return {
      presence: {
        allowEmpty: false
      },
      format: {
        pattern: /^(\s*|00|10|20|30|40|41|50|60)$/,
        message: "ICMS CST inválido. Deve ser vazio ou conter um valor válido"
      }
    };
  },
  "default_taxes.icms.cfop": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (
      attributes.fiscal_informations.crt_code !== "3" ||
      ["none", "", "30", "50"].includes(attributes.default_taxes.icms.cst)
    ) {
      return null;
    }

    return {
      presence: {
        allowEmpty: false
      },
      format: {
        pattern: /^(\s*|5000|5100|5101|5102|5103|5104|5105|5106|5107|5108|5109|5110|5111|5112|5113|5114|5115|5116|5117|5118|5119|5120|5122|5123|5124|5125|5150|5151|5152|5153|5154|5155|5156|5200|5201|5202|5203|5204|5205|5206|5207|5208|5209|5210|5250|5251|5252|5253|5254|5255|5256|5257|5258|5300|5301|5302|5303|5304|5305|5306|5307|5350|5351|5352|5353|5354|5355|5356|5357|5359|5360|5400|5401|5402|5403|5404|5405|5408|5409|5410|5411|5412|5413|5414|5415|5450|5451|5500|5501|5502|5503|5504|5505|5550|5551|5552|5553|5554|5555|5556|5557|5600|5601|5602|5603|5604|5605|5606|5651|5652|5653|5654|5655|5656|5657|5658|5659|5660|5661|5662|5663|5664|5665|5666|5900|5901|5902|5903|5904|5905|5906|5907|5908|5909|5910|5911|5912|5913|5914|5915|5916|5917|5918|5919|5920|5921|5922|5923|5924|5925|5926|5927|5928|5929|5931|5932|5933|5949|6000|6100|6101|6102|6103|6104|6105|6106|6107|6108|6109|6110|6111|6112|6113|6114|6115|6116|6117|6118|6119|6120|6121|6122|6123|6124|6125|6150|6151|6152|6153|6154|6155|6156|6200|6201|6202|6203|6204|6205|6206|6207|6208|6209|6210|6250|6251|6252|6253|6254|6255|6256|6257|6258|6300|6301|6302|6303|6304|6305|6306|6307|6350|6351|6352|6353|6354|6355|6356|6357|6359|6400|6401|6402|6403|6404|6408|6409|6410|6411|6412|6413|6414|6415|6500|6501|6502|6503|6504|6505|6550|6551|6552|6553|6554|6555|6556|6557|6600|6603|6651|6652|6653|6654|6655|6656|6657|6658|6659|6660|6661|6662|6663|6664|6665|6666|6900|6901|6902|6903|6904|6905|6906|6907|6908|6909|6910|6911|6912|6913|6914|6915|6916|6917|6918|6919|6920|6921|6922|6923|6924|6925|6929|6931|6932|6933|6949|7000|7100|7101|7102|7103|7104|7105|7106|7127|7200|7201|7202|7203|7204|7205|7206|7207|7210|7211|7250|7251|7300|7301|7350|7358|7500|7501|7550|7551|7553|7556|7651|7654|7900|7930|7949)$/,
        message: "CFOP inválido. Deve ser vazio ou conter um valor válido"
      }
    };
  },
  "default_taxes.icms.modBC": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (
      attributes.fiscal_informations.crt_code !== "3" ||
      !["00", "10", "20"].includes(attributes.default_taxes.icms.cst)
    ) {
      return null;
    }

    return {
      presence: {
        allowEmpty: false,
        message: "Esse campo não pode estar vazio"
      },
      format: {
        pattern: /^(\s*|0|1|2|3)$/,
        message: "Campo inválido."
      }
    };
  },
  "default_taxes.icms.modBCST": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (
      attributes.fiscal_informations.crt_code !== "3" ||
      !["10", "30"].includes(attributes.default_taxes.icms.cst)
    ) {
      return null;
    }

    return {
      presence: {
        allowEmpty: false,
        message: "Esse campo não pode estar vazio"
      },
      format: {
        pattern: /^(\s*|0|1|2|3|4|5)$/,
        message: "Campo inválido."
      }
    };
  },
  "default_taxes.icms.motDesICMS": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (
      attributes.fiscal_informations.crt_code !== "3" ||
      !["30", "20"].includes(attributes.default_taxes.icms.cst)
    ) {
      return null;
    }

    return {
      presence: {
        allowEmpty: false,
        message: "Esse campo não pode estar vazio"
      },
      format: {
        pattern: /^(\s*|3|9|12)$/,
        message: "Campo inválido."
      }
    };
  },
  "default_taxes.csosn": {
    format: {
      pattern: /^(\s*|101|102|103|201|202|203|300|400|500|900)$/,
      message: "CSOSN inválido. Deve ser vazio ou conter um valor válido"
    }
  },
  "fiscal_informations.accountant_email": {
    format: {
      pattern: new RegExp(`${validate.validators.email.PATTERN.source}|^$`),
      message: "Email da contabilidade com formato inválido"
    }
  },
  "fiscal_informations.crt_code": {
    format: {
      pattern: /^[1-3]$|^$/,
      message: "CRT inválido"
    }
  },
  "fiscal_informations.iest_code": {
    format: {
      pattern: /^\d{2,14}$|^$/,
      message: "IEST com formato inválido"
    }
  },
  "fiscal_informations.csc_id": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (
      !attributes.fiscal_informations.csc_id ||
      attributes.fiscal_informations.csc_id.length === 0
    )
      return null;

    return {
      length: {
        minimum: 6,
        maximum: 6,
        message: "O ID deve ter 6 caracteres"
      }
    };
  },
  "fiscal_informations.certificate_password": function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (
      !attributes.fiscal_informations.certificate ||
      attributes.fiscal_informations.certificate.length === 0
    )
      return null;

    return {
      presence: {
        allowEmpty: false,
        message: "Informe a senha do certificado"
      }
    };
  }
};

export default {
  general,
  taxes
};



// WEBPACK FOOTER //
// ./src/core/constraint/company.constraint.js